import React from "react";
import "./Playhead.scss";

// PlayheadHandle — sits on the ruler
export function PlayheadHandle({ x, onPointerDown }) {
  return (
    <div className="it-playhead-handle" style={{ left: x }} onPointerDown={onPointerDown}>
      <div className="it-playhead-handle__arrow" />
      <div className="it-playhead-handle__stem" />
    </div>
  );
}

// PlayheadLine — spans all track rows
export function PlayheadLine({ x, onPointerDown }) {
  return <div className="it-playhead-line" style={{ left: x }} onPointerDown={onPointerDown} />;
}
